import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { ToolbarModule } from 'primeng/toolbar';
import { TableModule } from 'primeng/table';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { HvlFormItemModule, HvlMlDropdownModule } from '@hvlng/framework-core/form';
import { UiConfirmationDialogService, UiSharedModule, UiUtilModule } from 'ui-shared';
import { CodeTextPageComponent } from './component/code-text-page/code-text-page.component';
import { CodeTextListComponent } from './component/code-text-list/code-text-list.component';
import { CodeTextRoutingModule } from './code-text-routing.module';
import { MenuModule } from 'primeng/menu';
import { HumanresourcesCommonSharedModule } from '../../humanresources-common-shared.module';
import { AccordionModule } from 'primeng/accordion';
import { HrFormButtonsModule } from '../../common/component/hr-form-buttons/hr-form-buttons.module';
import { TranslateModule } from '@ngx-translate/core';
import { HrAccordionModule } from '../../common/component/hr-accordion/hr-accordion.module';
import { CodeTextFormComponent } from './component/code-text-form/code-text-form.component';
import { HrFormInputModule } from '../../common/component/hr-form-input/hr-form-input.module';
import { HrShimmerModule } from '../../common/component/hr-shimmer/hr-shimmer.module';

@NgModule({
    declarations: [CodeTextPageComponent, CodeTextListComponent, CodeTextFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        PrimengSharedModule,
        ToolbarModule,
        TableModule,
        DynamicDialogModule,
        HvlFormItemModule,
        HvlNgSharedModule,
        CodeTextRoutingModule,
        HvlMlDropdownModule,
        UiUtilModule,
        UiSharedModule,
        MenuModule,
        HumanresourcesCommonSharedModule,
        HumanresourcesCommonSharedModule.forRoot(),
        AccordionModule,
        HrFormButtonsModule,
        TranslateModule,
        HrAccordionModule,
        HrFormInputModule,
        HrShimmerModule,
    ],
    providers: [DialogService, UiConfirmationDialogService],
})
export class CodeTextModule {}
